import Iconify from "../../../shared/components/Iconify";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export const BillPresentMentLinks = [
    {
        title: 'Bill Presentment',
        path: '/shop-dashboard/savings-account/bill-presentation',
        icon: getIcon('icon-park:bill'),

    }
]
